































































































import { Component, Vue } from "vue-property-decorator";
import NavMenuVue from "./NavMenu.vue";
import { mapGetters } from "vuex";
import HeaderSearchVue from "./HeaderSearch.vue";
import RemarksVue from "./Remarks.vue";
import AccountInfoVue from "../AccountBookList/AccountInfo.vue";
import AddRemarkVue from "./AddRemark.vue";
import AccountBookImportVue from "./AccountBookImport.vue";
import UpdateNoticeVue from "@/components/app/UpdateNotice.vue";

@Component({
    ...mapGetters(["currentIcon", "accountBook"]),
    components: {
        "nav-menu": NavMenuVue,
        "header-search": HeaderSearchVue,
        "account-info": AccountInfoVue,
        "remarks": RemarksVue,
        "add-remark": AddRemarkVue,
        "accountBook-import": AccountBookImportVue,
        "update-notice": UpdateNoticeVue,
    }
})
export default class MainHeader extends Vue {
    mounted() { }
    importer: boolean = false;
    // 新建客户 模态框
    accountInfo: boolean = false;
    accountAdd() {
        this.accountInfo = true;
    }
    // 模态框 close
    closeInfo() {
        this.accountInfo = false;
    }
    infoSuccess(data: AccountBookList.AccountBook) {
        Vue.axios
            .post(
                `accountbooks/` + data.id)
            .then(res => {
                this.$store.dispatch("changeAccounBook", res.data);
                this.$utils.setTaxType(res.data);
                this.$utils.getRemarks();
                this.$router.push("/voucherlist");
            });
        this.accountInfo = false;
    }

    // 展示打印
    showPrint() {
        // 通知app.vue以打开全局的print遮罩
        this.$emit("showPrint");
    }

    emitSearch() {
        // 通知app.vue以打开全局搜索
        this.$emit("search");
    }

    // 显示归档
    showArchive() {
        this.$emit("archive");
    }
    // 显示备注
    isRemarks: boolean = false
    showRemarks() {
        this.isRemarks = true;
    }
    hideRemarks() {
        this.isRemarks = false;
    }
    // 新增备注
    reData: AccountBookList.AccountRemark | null = null
    isAddremark: boolean = false
    addRemark(data: AccountBookList.AccountRemark) {
        this.reData = null;
        if (data) this.reData = data;
        else this.reData = null;
        this.isAddremark = true;
    }
    closeAddRemark() {
        this.isAddremark = false;
    }
    // 打开账套弹窗
    showInfo() {
        this.$emit("showBookInfo");
    }
    changeBook() {
        this.$emit("changeBook")
    }
    showNotice:boolean = false
}
